import home from '../screens/home.vue';
const sandbox = '/sandboxfront';
export const routes = [
    {path:`/solucoesComparativas`, name:'solucoesComparativas',component: home}
];


// WEBPACK FOOTER //
// ./src/routes/index.js